import { render, staticRenderFns } from "./ProfessionalCaring.vue?vue&type=template&id=493ce817&"
import script from "./ProfessionalCaring.vue?vue&type=script&lang=js&"
export * from "./ProfessionalCaring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports